

import { FC, PropsWithChildren } from 'react';

import { IconButton } from '@eneco/sparky';
import { HelpIcon } from '@eneco/sparky/icons';

interface Props {
  label?: string;
  onClick?: () => void;
}

export const NavigationHelpButton: FC<PropsWithChildren<Props>> = ({ label, onClick }) => (
  <IconButton label={label || 'question'} onClick={onClick}>
    <HelpIcon color="iconSecondary" />
  </IconButton>
);
